


import styled from 'styled-components';

import { colors, fonts } from '../../shared/tokens';
import { Section } from '../landingShared';

const PANELS = [
  {
    name: 'UMBRELLA',
    suffix: 'OS',
    color: colors.cyan,
    suffixColor: '#1e8a93',
    discipline: 'Software Platform',
    address: '21 Avenue Dollard la salle, Quebec h2n 1s2',
    glow: colors.cyan,
  },
  {
    name: 'TEMPORA',
    suffix: ' ®',
    color: colors.red,
    suffixColor: colors.ink,
    discipline: 'Industrial Heating Solutions',
    address: '795 George V. Avenue Lachine, Quebec H8S 1L2',
    glow: colors.red,
  },
];

const Together = () => (
  <Section>
    <Divider aria-hidden />
    <Wrap>
      <Panels>
        {PANELS.map((p) => (
          <Panel key={p.name}>
            <Brand style={{ color: p.color }}>
              {p.name}
              <Suffix style={{ color: p.suffixColor }}>{p.suffix}</Suffix>
            </Brand>
            <Discipline>{p.discipline}</Discipline>
            <Address>{p.address}</Address>
            <Glow style={{ background: p.glow }} />
          </Panel>
        ))}
      </Panels>
    </Wrap>
  </Section>
);

export default Together;

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 5%,
    rgba(56, 200, 212, 0.2) 30%,
    rgba(56, 200, 212, 0.2) 70%,
    rgba(0, 0, 0, 0) 95%
  );
`;

const Wrap = styled.div`
  max-width: 1060px;
  margin: 0 auto;
  padding: 100px 80px;

  @media (max-width: 768px) {
    padding: 64px 24px;
  }
`;

const Panels = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

const Panel = styled.div`
  position: relative;
  overflow: hidden;
  height: 216px;
  padding: 53.5px 52.75px 56.75px;
  border-radius: 8px;
  background: #0d1420;
  border: 0.75px solid ${colors.hairline};
  border-top: 1.5px solid ${colors.hairline};
`;

const Brand = styled.p`
  font-family: ${fonts.condensed};
  font-weight: 900;
  font-size: 32px;
  line-height: 32px;
  letter-spacing: 1.92px;
  text-transform: uppercase;
`;

const Suffix = styled.span`
  font-size: 18px;
  line-height: 18px;
`;

const Discipline = styled.p`
  margin-top: 4px;
  font-family: ${fonts.mono};
  font-size: 10px;
  line-height: 15px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: ${colors.muted2};
`;

const Address = styled.p`
  margin-top: 28px;
  max-width: 315px;
  font-family: ${fonts.condensed};
  font-weight: 800;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: #ffffff;
`;

const Glow = styled.span`
  position: absolute;
  right: -50px;
  bottom: -120px;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  opacity: 0.05;
  pointer-events: none;
`;
